// This file was automatically generated from chooseAccount.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.chooseAccount');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.chooseAccount.accountChooser = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var userList28 = opt_data.users;
  var userListLen28 = userList28.length;
  for (var userIndex28 = 0; userIndex28 < userListLen28; userIndex28++) {
    var userData28 = userList28[userIndex28];
    output.append('<a href="', soy.$$escapeHtml(userData28.signinUrl), '" class="el8Btn el8BtnPrimary el8BtnLg el8BtnBlock">', soy.$$escapeHtml(userData28.name), (userData28.email) ? '<span class="el8CenterBlock el8NormalWeight el8FontBase">' + soy.$$escapeHtml(userData28.email) + '</span>' : '', '</a>');
  }
  output.append('<p class="el8AlignCenter mtSm">or</p><a href="', soy.$$escapeHtml(opt_data.signupUrl), '" class="el8Btn el8BtnDefault el8BtnLg el8BtnBlock">My name is not listed here</a><div class="el8LgSpacer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.chooseAccount.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">View charts sent to your practice via Elation</h3><div class="el8MdSpacer"></div><h4 class="el8AlignCenter mbMd">Log in as:</h4><div class="el8CenterBlock w70p" id="account-chooser-container"></div></div>');
  if (!opt_sb) return output.toString();
};
